import { Link } from "react-router-dom";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Truck, Plane, ShieldCheck, Mail } from "lucide-react";

const EMAIL = "teacuppuppies4sale@gmail.com";

const OPTIONS = [
  {
    icon: Truck,
    title: "Local USA Delivery",
    body: "For families across the United States, we offer white-glove ground and short-haul air delivery. Your puppy travels in climate-controlled comfort, accompanied every mile of the way.",
  },
  {
    icon: Plane,
    title: "International Flight Nanny",
    body: "Welcoming families worldwide, we arrange a dedicated flight nanny who personally carries your puppy in-cabin. All health certificates, export permits, and documentation are handled for you.",
    tiktok: "https://www.tiktok.com/@pet.flight.nanny?_r=1&_t=ZP-98ccpDvYN0Z",
    tiktokLabel: "Meet our flight nanny on TikTok",
  },
  {
    icon: ShieldCheck,
    title: "Safe & Fully Documented",
    body: "Every journey includes veterinary travel clearance, a comfort kit, and live updates. Your puppy's safety and calm are our highest priority from our door to yours.",
  },
];

export default function Shipping() {
  return (
    <div data-testid="shipping-page">
      <PageHero
        eyebrow="Delivery & Shipping"
        title={["Delivered safely,", "anywhere in the world."]}
        subtitle="From your neighborhood to another continent, we bring your puppy home with the utmost care."
      />
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-10">
        <div className="grid md:grid-cols-3 gap-8">
          {OPTIONS.map((o, i) => (
            <Reveal key={o.title} delay={i * 0.1}>
              <div className="h-full bg-white border border-[#E2D1C3] rounded-md p-9">
                <o.icon size={32} className="text-[#C8A98E] mb-6" strokeWidth={1.4} />
                <h3 className="font-heading text-3xl text-[#2A2118] mb-4">{o.title}</h3>
                <p className="text-[#5c5245] font-light leading-relaxed">{o.body}</p>
                {o.tiktok && (
                  <a
                    href={o.tiktok}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="flight-nanny-tiktok"
                    className="inline-flex items-center gap-2 mt-5 text-sm text-[#2A2118] border-b border-[#C8A98E] pb-1 hover:text-[#C8A98E] transition-colors"
                  >
                    {o.tiktokLabel}
                  </a>
                )}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-14 bg-[#2A2118] rounded-md px-8 md:px-16 py-16 text-center">
            <p className="label-eyebrow text-[#E6C5C0] mb-5">Personalized Quotes</p>
            <h2 className="font-heading text-4xl md:text-5xl font-light text-[#FDFBF7] max-w-2xl mx-auto leading-tight">
              Delivery costs vary by destination. Email us for a tailored quote.
            </h2>
            <div className="flex flex-wrap justify-center gap-4 mt-9">
              <a
                href={`mailto:${EMAIL}?subject=Delivery%20Quote%20Request`}
                data-testid="shipping-email-btn"
                className="inline-flex items-center gap-2 bg-[#FDFBF7] text-[#2A2118] px-8 py-4 rounded-sm text-sm hover:bg-[#E6C5C0] transition-colors"
              >
                <Mail size={16} /> Email for a Quote
              </a>
              <Link to="/contact" className="inline-flex items-center border border-[#FDFBF7]/40 text-[#FDFBF7] px-8 py-4 rounded-sm text-sm hover:bg-white/10 transition-colors">
                Use Contact Form
              </Link>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
